import React from 'react';

class ArrowIcon extends React.Component {
  render() {
    return (
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={this.props.transform ? 'transform' : ''}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.73726 5.27279L-2.3886e-07 1.53553L1.41421 0.121321L5.15147 3.85858C5.55916 4.26626 5.82294 4.52895 6.03966 4.71293C6.24745 4.88933 6.34531 4.93391 6.39809 4.95106C6.59893 5.01631 6.81528 5.01631 7.01612 4.95106C7.0689 4.93391 7.16676 4.88933 7.37455 4.71293C7.59127 4.52895 7.85506 4.26626 8.26274 3.85858L12 0.12132L13.4142 1.53553L9.64971 5.30004C9.27697 5.67281 8.95541 5.99439 8.66891 6.23761C8.36651 6.49432 8.03804 6.72194 7.63416 6.85317C7.03163 7.04894 6.38259 7.04894 5.78006 6.85317C5.37617 6.72194 5.0477 6.49432 4.74531 6.23761C4.45881 5.99439 4.13725 5.67281 3.76451 5.30005C3.75546 5.29099 3.74637 5.28191 3.73726 5.27279Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default ArrowIcon;
